var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconChevronDropdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53516 13.7148L4.28516 8.46484C4.01172 8.21875 4.01172 7.80859 4.28516 7.53516C4.53125 7.28906 4.94141 7.28906 5.21484 7.53516L10 12.3477L14.7852 7.5625C15.0312 7.28906 15.4414 7.28906 15.7148 7.5625C15.9609 7.80859 15.9609 8.21875 15.7148 8.46484L10.4375 13.7148C10.1914 13.9883 9.78125 13.9883 9.53516 13.7148Z",
    fill: "#22283C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronDropdown);
export default __webpack_public_path__ + "static/media/icon-chevron-dropdown.bcb5b66db155d97bf15b19ccdf6fb1c8.svg";
export { ForwardRef as ReactComponent };